import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../static/css/pendingorders.css";
import { FaArrowRight } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { IoMdLogOut } from "react-icons/io";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import "../../static/css/App.css";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";
library.add(fas, fab, far);


const HeaderNavBar = () => {
  const user = useSelector(selectCurrentUser);
  // console.log('user',user);
  return (
    <div>
      {/* Navbar */}
      <Navbar bg="danger" variant="dark" className="py-2">
        <Container fluid>
          <Navbar.Brand href="#" className="text-white">
            <FaArrowRight />
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text className="mx-2 d-flex align-items-center text-white">
              <CgProfile className="me-1" /> {user.userName}
            </Navbar.Text>
            <Nav.Link
              className="d-flex align-items-center text-white"
              href="/admin/logout"
            >
              <IoMdLogOut className="me-1" /> Logout
            </Nav.Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default HeaderNavBar;
